export const CloseIcon = () => (
  <svg viewBox="0 0 32 32">
    <path
      d="M8.71,7.29,16,14.59l7.29-7.3,1.42,1.42L17.41,16l7.3,7.29-1.42,1.42L16,17.41l-7.29,7.3L7.29,23.29,14.59,16,7.29,8.71Z"
      fill="currentColor"
    />
  </svg>
);
